import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=2c6bc3df&"
import script from "./Distribute.vue?vue&type=script&lang=js&"
export * from "./Distribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports